import { render, staticRenderFns } from "./AlbumContent.vue?vue&type=template&id=ab5b8038&scoped=true&"
import script from "./AlbumContent.vue?vue&type=script&lang=js&"
export * from "./AlbumContent.vue?vue&type=script&lang=js&"
import style0 from "./AlbumContent.vue?vue&type=style&index=0&id=ab5b8038&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5b8038",
  null
  
)

export default component.exports